/**
 * Document-scoped session replay flag (survives React Strict Mode for the first start).
 *
 * After `shutdownSessionReplay` (e.g. Gas rotation while ineligible), {@link SessionReplayDocumentState.reset}
 * clears state so {@link SessionReplayInitializer} may call `initializeSessionReplay` again — multiple
 * start/stop cycles per document are intentional.
 *
 * Use {@link sessionReplayDocumentState} rather than module-level `let` exports: private field avoids
 * accidental mutation, and `isInitialized` is always read at access time (no stale captured binding).
 */
export class SessionReplayDocumentState {
  private _initialized = false;

  get isInitialized(): boolean {
    return this._initialized;
  }

  markInitialized(): void {
    this._initialized = true;
  }

  reset(): void {
    this._initialized = false;
  }
}

export const sessionReplayDocumentState = new SessionReplayDocumentState();
